// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__2nETp"};